module.exports = "/images/vendor/desiigner-svg/svg/ui/input-checkbox.svg?2a9a790ea4fad55cd110e339646d210c";